
/*
* 运输司机页面路径枚举
* */
export enum TmsPath {
    // 运输列表
    TMS_TRANSPORTING = "/tms/transporting",
    // 运输任务详情
    TMS_TRANSPORTING_DETAIL = "/tms/transporting/detail/:taskWayPointId/:waypointType",
    // 运输任务到达详情
    TMS_TRANSPORTING_ARRIVING = "/tms/transporting/arriving/:taskWayPointId",
    // 异常上报
    TMS_TRANSPORT_EXCEPTION = "/tms/transport/exception/:taskId",
    // 运输设置
    TMS_TRANSPORT_SETTINGS = "/tms/transport/settings",
    // 运输语言设置
    TMS_TRANSPORT_SETTINGS_LANGUAGE = "/tms/transport/settings/language",
    // 运输默认导航地图设置
    TMS_TRANSPORT_SETTINGS_NAVIGATION_APP = "/tms/transport/settings/navigation-app",
    // 已完成页面
    TMS_TRANSPORT_FINISHED = "/tms/transport/finished",
    // 已完成详情页面
    TMS_TRANSPORT_FINISHED_DETAIL = "/tms/transport/finished/detail/:taskWayPointId/:taskId/:selectedDate",
    // 异常上报记录页面
    TMS_TRANSPORT_EXCEPTION_REPORTED = "/tms/transport/exception/reported"

}

export enum TmsPathPre {
    // 运输任务详情前缀
    TMS_TRANSPORTING_DETAIL_PRE = "/tms/transporting/detail/",
    // 运输任务到达详情前缀
    TMS_TRANSPORTING_ARRIVING_PRE= "/tms/transporting/arriving/",
    // 异常上报前缀
    TMS_TRANSPORTING_EXCEPTION_PRE = "/tms/transport/exception/",
    // 已完成详情前缀
    TMS_TRANSPORT_FINISHED_DETAIL_PRE = "/tms/transport/finished/detail/",

}

